"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDealSetupTrade = exports.mapDealSetupSource = void 0;
var mapDealSetupSource = function (dealSetupSource) {
    switch (dealSetupSource) {
        case 'KBB': {
            return 'SD';
        }
        case 'ICO':
        default: {
            return dealSetupSource;
        }
    }
};
exports.mapDealSetupSource = mapDealSetupSource;
var mapDealSetupTrade = function (dealSetupTrade) {
    var _a = dealSetupTrade || {}, amountOwed = _a.amountOwed, condition = _a.condition, isNetTradeAppliedToFinancing = _a.isNetTradeAppliedToFinancing, make = _a.make, mileage = _a.mileage, model = _a.model, source = _a.source, status = _a.status, trim = _a.trim, value = _a.value, vin = _a.vin, year = _a.year;
    if (!value && !amountOwed && !condition && !make && !model && !mileage && !year) {
        return null;
    }
    var tradeIn = {
        amountOwed: amountOwed,
        condition: condition,
        isAmountAppliedToFinancing: isNetTradeAppliedToFinancing,
        make: make || null,
        makeId: null,
        mileage: mileage,
        model: model || null,
        modelId: null,
        owed: amountOwed || 0,
        ownershipType: null,
        source: (0, exports.mapDealSetupSource)(source),
        status: status,
        trim: trim || null,
        trimId: null,
        value: value || 0,
        vehicleId: null,
        vehicleOptions: {},
        vin: vin,
        year: year || null
    };
    return tradeIn;
};
exports.mapDealSetupTrade = mapDealSetupTrade;
